import {
  assign,
  createMachine,
  ErrorPlatformEvent,
  Interpreter,
} from 'xstate-v4'
import sentryCapture from '~/utility/sentryCapture'
import { Faq, FaqStandalone } from './schemas'
import { FaqAllEvent, FaqStandaloneEvent } from './types'

export type FaqEvent = FaqAllEvent | FaqStandaloneEvent

interface FaqContext {
  all: Faq[]
  standalone: FaqStandalone | null
}

function getContextInitial() {
  return {
    all: [],
    standalone: null,
  }
}

export function returnFaqMachine() {
  return createMachine<FaqContext, FaqEvent>(
    {
      context: getContextInitial(),
      initial: 'idle',
      states: {
        idle: {
          on: {
            FETCH_ALL: 'fetchingAll',
            FETCH_STANDALONE: 'fetchingStandalone',
          },
        },
        fetchingAll: {
          invoke: {
            src: 'fetchAll',
            onDone: {
              target: 'idle',
              actions: assign({
                all: (_, { data }) => data,
              }),
            },
            onError: {
              actions: 'logError',
              target: 'error',
            },
          },
        },
        fetchingStandalone: {
          invoke: {
            src: 'fetchStandalone',
            onDone: {
              target: 'idle',
              actions: assign({
                standalone: (_, { data }) => data,
              }),
            },
            onError: {
              actions: 'logError',
              target: 'error',
            },
          },
        },
        error: {},
      },
    },
    {
      actions: {
        logError: (_, _event: any) => {
          const event: ErrorPlatformEvent = _event
          event.data.name = 'faqMachine ' + event.type + ' error'
          sentryCapture(event.data)
        },
      },
      services: {
        fetchAll: () => {
          throw new Error('faqMachine fetchAll not implemented')
        },
        fetchStandalone: () => {
          throw new Error('faqMachine fetch not implemented')
        },
      },
    },
  )
}

export type FaqMachineInterpreter = Interpreter<FaqContext, any, FaqEvent>
